import {
  SET_PENDING_USERNAME,
  SET_PENDING_PASSWORD,
  SET_PENDING_PASSWORD_CONFIRM,
  SET_ADDUSER_SAVING,
  SET_PENDING_EMAIL,
  SET_PENDING_FULLNAME,
  SET_INVITE_ERROR,
  SET_INVITE_LOADING
} from '../../actions/page/Invites';

export default function Invites(state = {}, action) {
  switch (action.type) {
    case SET_PENDING_USERNAME:
      return { ...state, username: action.username };
    case SET_PENDING_EMAIL:
      return { ...state, email: action.email };
    case SET_PENDING_FULLNAME:
      return { ...state, fullName: action.fullName };
    case SET_PENDING_PASSWORD:
      return { ...state, password: action.password };
    case SET_PENDING_PASSWORD_CONFIRM:
      return { ...state, passwordConfirm: action.passwordConfirm };
    case SET_ADDUSER_SAVING:
      return { ...state, saving: action.saving };
    case SET_INVITE_ERROR:
      return { ...state, error: action.error };
    case SET_INVITE_LOADING:
      return { ...state, loading: action.loading };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/Invites.js